import React, { useEffect, useState, useCallback } from "react";
import FormularioComissao from "../../Formulario/FormularioComissao";
import SidebarAdmin from "../../menu/SidebarAdmin";
import Topbar from "../../menu/Topbar";
import TabelaExtratoAdmin from "./TabelaExtratoAdmin";
import Api from "../../Services/Api";

const LancarComissao = () => {
  const [menuClose, setMenuClose] = useState(false);
  const [licenciados, setLicenciados] = useState([]);
  const [extratoDados, setExtratoDados] = useState([]);

  const toggleMenu = () => setMenuClose((prev) => !prev);

  const onItemAtualizado = (novo) => {
    setExtratoDados((prev) =>
      prev.map((x) =>
        x.id === novo.id
          ? { ...x, ...novo, user_name: novo.user_name ?? x.user_name }
          : x
      )
    );
  };

  // ✅ carrega licenciados
  useEffect(() => {
    Api.get("/users?role=LICENSED")
      .then((res) => setLicenciados(res.data))
      .catch((err) => console.error("Erro ao buscar licenciados", err));
  }, []);

  // ✅ função para carregar extrato do banco
  const carregarExtrato = useCallback(() => {
    Api.get("/ledger-entries?limit=200")
      .then((res) => setExtratoDados(res.data))
      .catch((err) => console.error("Erro ao buscar extrato", err));
  }, []);

  // ✅ carrega extrato ao abrir a tela
  useEffect(() => {
    carregarExtrato();
  }, [carregarExtrato]);

  // ✅ quando salva, adiciona no topo (ou se preferir, chama carregarExtrato())
  const aNovoLancamentoAdicionado = (lancamento) => {
    setExtratoDados((prev) => [lancamento, ...prev]);
    // alternativa mais “100% banco”: carregarExtrato();
  };

  return (
    <div className="app-container">
      <SidebarAdmin close={menuClose} comissaoActive="active" />

      <main className="main-content">
        <Topbar page="Lançar Comissão" onToggleMenu={toggleMenu} />

        <FormularioComissao
          licenciados={licenciados}
          lancamentoAdicionado={aNovoLancamentoAdicionado}
        />

        <TabelaExtratoAdmin
          itensLista={extratoDados}
          licenciados={licenciados}
          onItemAtualizado={onItemAtualizado}
        >
          Extrato Admin
        </TabelaExtratoAdmin>

      </main>
    </div>
  );
};

export default LancarComissao;
